// Auto-generated by scripts/applyCheckedItemStatsDraft.js
// Only itemStatsDraft.json entries with check: 1 are applied.
// 아이템 능력치 수정 위치
// 패치로 아이템 능력치가 변경되면 이 파일의 stats 값을 수정하세요.
// 시뮬레이터는 이 파일의 값을 기준으로 장비 스탯을 계산합니다.

export const DEFAULT_ITEM_STATS = {
  "attackPower": 0,
  "skillAmp": 0,
  "defense": 0,
  "maxHp": 0,
  "maxSp": 0,
  "hpRegen": 0,
  "spRegen": 0,
  "attackSpeed": 0,
  "critChance": 0,
  "critDamage": 0,
  "cooldownReduction": 0,
  "cooldownReductionPercent": 0,
  "moveSpeed": 0,
  "armorPenetration": 0,
  "armorPenetrationPercent": 0,
  "skillAmpPenetration": 0,
  "healingReduction": 0,
  "criticalStrikeChance": 0,
  "criticalStrikeDamage": 0,
  "critChancePercent": 0,
  "critDamagePercent": 0,
  "lifeSteal": 0,
  "lifeStealPercent": 0,
  "omnivamp": 0,
  "attackSpeedPercent": 0,
  "moveSpeedPercent": 0,
  "moveSpeedFlat": 0,
  "omniVampPercent": 0,
  "basicAttackRange": 0,
  "crowdControlResistance": 0,
  "crowdControlResistancePercent": 0,
  "basicAttackAmpPercent": 0,
  "basicAttackAmpPerLevelMin": 0,
  "basicAttackAmpPerLevelMax": 0,
  "maxHpPerLevelMin": 0,
  "maxHpPerLevelMax": 0
};

export const itemStats = {
  "016. Vital Sign Censor": {
    "attackPower": 0,
    "skillAmp": 0,
    "defense": 0,
    "maxHp": 0,
    "maxSp": 0,
    "hpRegen": 0,
    "spRegen": 0,
    "attackSpeed": 0,
    "critChance": 0,
    "critDamage": 0,
    "cooldownReduction": 0,
    "cooldownReductionPercent": 0,
    "moveSpeed": 0,
    "armorPenetration": 0,
    "armorPenetrationPercent": 0,
    "skillAmpPenetration": 0,
    "healingReduction": 0,
    "criticalStrikeChance": 0,
    "criticalStrikeDamage": 0,
    "critChancePercent": 26,
    "critDamagePercent": 0,
    "lifeSteal": 0,
    "lifeStealPercent": 0,
    "omnivamp": 0,
    "attackSpeedPercent": 33,
    "moveSpeedPercent": 0,
    "moveSpeedFlat": 0,
    "omniVampPercent": 0,
    "basicAttackRange": 0,
    "crowdControlResistance": 0,
    "crowdControlResistancePercent": 0,
    "basicAttackAmpPerLevelMin": 0,
    "basicAttackAmpPerLevelMax": 0,
    "maxHpPerLevelMin": 0,
    "maxHpPerLevelMax": 0
  },
  "040. Tactical Shoes": {
    "attackPower": 20,
    "skillAmp": 0,
    "defense": 0,
    "maxHp": 150,
    "maxSp": 0,
    "hpRegen": 0,
    "spRegen": 0,
    "attackSpeed": 0,
    "critChance": 0,
    "critDamage": 0,
    "cooldownReduction": 15,
    "cooldownReductionPercent": 0,
    "moveSpeed": 0,
    "armorPenetration": 0,
    "armorPenetrationPercent": 0,
    "skillAmpPenetration": 0,
    "healingReduction": 0,
    "criticalStrikeChance": 0,
    "criticalStrikeDamage": 0,
    "critChancePercent": 0,
    "critDamagePercent": 0,
    "lifeSteal": 0,
    "lifeStealPercent": 0,
    "omnivamp": 0,
    "attackSpeedPercent": 0,
    "moveSpeedPercent": 0,
    "moveSpeedFlat": 0.25,
    "omniVampPercent": 0,
    "basicAttackRange": 0,
    "crowdControlResistance": 0,
    "crowdControlResistancePercent": 0,
    "basicAttackAmpPerLevelMin": 0,
    "basicAttackAmpPerLevelMax": 0,
    "maxHpPerLevelMin": 0,
    "maxHpPerLevelMax": 0
  },
  "045. Pixie Boots": {
    "attackPower": 28,
    "skillAmp": 0,
    "defense": 0,
    "maxHp": 0,
    "maxSp": 0,
    "hpRegen": 0,
    "spRegen": 0,
    "attackSpeed": 0,
    "critChance": 0,
    "critDamage": 0,
    "cooldownReduction": 20,
    "cooldownReductionPercent": 0,
    "moveSpeed": 0,
    "armorPenetration": 0,
    "armorPenetrationPercent": 0,
    "skillAmpPenetration": 0,
    "healingReduction": 0,
    "criticalStrikeChance": 0,
    "criticalStrikeDamage": 0,
    "critChancePercent": 0,
    "critDamagePercent": 0,
    "lifeSteal": 0,
    "lifeStealPercent": 0,
    "omnivamp": 0,
    "attackSpeedPercent": 0,
    "moveSpeedPercent": 0,
    "moveSpeedFlat": 0.27,
    "omniVampPercent": 0,
    "basicAttackRange": 0,
    "crowdControlResistance": 0,
    "crowdControlResistancePercent": 0,
    "basicAttackAmpPerLevelMin": 0,
    "basicAttackAmpPerLevelMax": 0,
    "maxHpPerLevelMin": 0,
    "maxHpPerLevelMax": 0
  }
};
